<form class="step-form">
  <div class="grid-container">
    <div class="grid-x grid-padding-x formfield">
      <div class="cell text-center">
        <app-advisor-image class="image-intro" path="/stc/stc-intro.svg" [altText]="'stromcheck.eingabe.start.alt_text' | translate"></app-advisor-image>
      </div>

      <div class="cell">
        <h2>{{ 'stromcheck.einstieg.selection.headline' | translate }}</h2>
        @for (field of formConfig.getFieldsFromGroup(steps.currentStep.name); track field) {
          <div formfield [invalidIfEmpty]="false" [form]="form" [formModel]="field"  [formConfig]="formConfig" step="stromcheck" class="formfield "></div>
        }
      </div>

    </div>

    <div class="cell">
      <div class="callout lighter-gray" [innerHTML]="'stromcheck.eingabe.start.callout2' | translate"></div>
      <div class="callout" [innerHTML]="'stromcheck.eingabe.start.callout1' | translate"></div>
      <div class="callout">
        <div class="button-wrapper">
          <a [href]="shortVersionButtonUrl" (click)="saveData()" [class.disabled]="!form.valid" class="button inline-arrow-right"
          target="_blank">{{ 'stromcheck.einstieg.submit' | translate }}</a>
        </div>
      </div>
    </div>
  </div>
</form>
